/**
 * Human-readable message from an Axios error. The backend wraps errors as
 * `{ error: { message } }`; some endpoints return a bare `{ message }`.
 * Falls back to the provided default when neither is present.
 */
export function extractApiErrorMessage(err: unknown, fallback: string): string {
  const data = (err as { response?: { data?: { error?: { message?: string }; message?: string } } })
    ?.response?.data;
  return data?.error?.message || data?.message || fallback;
}
